import { render, staticRenderFns } from "./fechasCobro.vue?vue&type=template&id=d5cf8ee6"
import script from "./fechasCobro.vue?vue&type=script&lang=js"
export * from "./fechasCobro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports